module.exports = __webpack_public_path__ + "img/map_car.4f4878aa.png";